exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ir-spinner-container {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1050;\n  overflow: hidden;\n  outline: 0;\n  background-color: #DADADC;\n  opacity: 0.5; }\n\n.ir-spinner {\n  margin: 0;\n  position: absolute;\n  top: 50%;\n  left: 46%;\n  margin-right: -50%; }\n\n.local {\n  text-align: center;\n  padding-top: 30px;\n  padding-bottom: 20px; }\n\n.spinner-layer {\n  border-color: #1594A6 !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agir/src/app/components/loading-spinner/loading-spinner.component.scss
// module id = ../../../../../src/app/components/loading-spinner/loading-spinner.component.scss
// module chunks = main